/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Gift_Hide_PriceInputs */

const vi_order_gift_hide_price = /** @type {(inputs: Order_Gift_Hide_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ẩn giá`)
};

/**

* @param {Order_Gift_Hide_PriceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_gift_hide_price = /** @type {((inputs?: Order_Gift_Hide_PriceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Gift_Hide_PriceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_gift_hide_price(inputs)
});